import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const RatingPage = lazy(() => import('../pages/rating/page'));
const BonusesPage = lazy(() => import('../pages/bonuses/page'));
const ProvidersPage = lazy(() => import('../pages/providers/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/rating',
    element: <RatingPage />
  },
  {
    path: '/bonuses',
    element: <BonusesPage />
  },
  {
    path: '/providers',
    element: <ProvidersPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;